<div
  class="eva-progress"
  [class.eva-progress--indeterminate]="indeterminate"
  [class.eva-progress--striped]="striped"
  [class.eva-progress--animated]="animated"
  [class.eva-progress--small]="size === 'small'"
  [class.eva-progress--medium]="size === 'medium'"
  [class.eva-progress--large]="size === 'large'"
  [attr.role]="'progressbar'"
  [attr.aria-valuenow]="indeterminate ? null : normalizedValue"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
>
  <!-- Header: Label + Value -->
  <div *ngIf="label || showValue" class="eva-progress__header">
    <span *ngIf="label" class="eva-progress__label">{{ label }}</span>
    <span *ngIf="showValue && !indeterminate" class="eva-progress__value">{{ displayValue }}</span>
  </div>

  <!-- Track -->
  <div class="eva-progress__track">
    <!-- Bar -->
    <div
      class="eva-progress__bar"
      [class.eva-progress__bar--primary]="color === 'primary'"
      [class.eva-progress__bar--success]="color === 'success'"
      [class.eva-progress__bar--warning]="color === 'warning'"
      [class.eva-progress__bar--danger]="color === 'danger'"
      [class.eva-progress__bar--info]="color === 'info'"
      [ngStyle]="barStyle"
    ></div>
  </div>
</div>
